import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_TECHNOLOGIES,
  GET_TECHNOLOGIES_SUCCESS,
  ADD_TECHNOLOGY,
  ADD_TECHNOLOGY_SUCCESS,
  UPDATE_TECHNOLOGY,
  UPDATE_TECHNOLOGY_SUCCESS,
  DELETE_TECHNOLOGY,
  DELETE_TECHNOLOGY_SUCCESS,
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getTechnologyApi() {
  // api for get designation.
  const response = api.technologies().GetAllTechnologies();
  return response;
}
function addTechnologyApi(formData) {
  // api for add designation.
 const response= api.technologies().AddEditTechnology(formData);
 return response;
}

function updateTechnologyApi(formData) {
  // api for update designation.
  api.technologies().AddEditTechnology(formData);
}
function delTechnologyApi(delId) {
  // api for delete designation.
  const response = api.technologies().DeleteTechnology(delId);
  return response;
}

// get designation list.
export function* handleGetTechnology() {
  try {
    const response = yield call(getTechnologyApi);
    yield put({ type: GET_TECHNOLOGIES_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
export function* handleAddTechnology({ payload }) {
  try {
   const response= yield call(addTechnologyApi, payload);
   payload={...payload,"technologyId" :response.data};
    yield put({ type: ADD_TECHNOLOGY_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

export function* handleUpdateTechnology({ payload }) {
  try {
    let formData = payload;

    yield call(updateTechnologyApi, formData);
    yield put({ type: UPDATE_TECHNOLOGY_SUCCESS, payload: formData });
  } catch (error) {
     
  }
}

export function* handleDelTechnology({ payload }) {
  try {
    yield call(delTechnologyApi, payload);
    yield put({ type: DELETE_TECHNOLOGY_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

// watach function.
export function* technologiesWatchFun() {
  yield takeLatest(GET_TECHNOLOGIES, handleGetTechnology);
  yield takeLatest(ADD_TECHNOLOGY, handleAddTechnology);  
  yield takeLatest(UPDATE_TECHNOLOGY, handleUpdateTechnology);  
  yield takeLatest(DELETE_TECHNOLOGY, handleDelTechnology);
}
